<template>
  <div>
    <!-- <b-breadcrumb style="background-color:#f8f9fa" :items="itemsBreadcrumb"></b-breadcrumb> -->

    <b-row>
      <b-col cols="12">
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <b-card class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0">
            <b-navbar toggleable="lg">
              <b-navbar-brand href="#">
                <strong style="color:#3b3e66">Complaints</strong>
              </b-navbar-brand>
              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto">
                <b-nav-form>
                  <b-button
                    variant="outline-info"
                    size="sm"
                    class="mr-2"
                    @click="reloadTable"
                  >
                    <font-awesome-icon icon="sync" />
                  </b-button>
                  <b-form-group>
                    <b-input-group size="sm">
                      <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          :disabled="!filter"
                          @click="filter = ''"
                        >Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-nav-form>
              </b-navbar-nav>
            </b-navbar>
            <b-table
              sticky-header="calc(100vh - 255px)"
              ref="table"
              bordered
              id="users-data-table"
              :busy.sync="isLoading"
              :items="getComplaintsTableData"
              :fields="staticFields"
              :filter="filter"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              responsive="sm"
            >
              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="field.width ? 'width:'+field.width : ''"
                />
              </template>
              <template v-slot:cell(created_at)="data">
                <p>{{ createdAtDate(data.item.created_at) }}</p>
              </template>
              <template v-slot:cell(status)="data">
                <b-badge
                  v-if="data.item.status == 1"
                  variant="info"
                >OPEN</b-badge>
                <b-badge
                  v-else-if="data.item.status == 2"
                  variant="success"
                >ClOSED</b-badge>
                <b-badge
                  v-else-if="data.item.status == 3"
                  variant="warning"
                >ON-HOLD</b-badge>
              </template>
              <template v-slot:cell(owner)="data">{{data.item.assigned_to_first_name + ' ' + data.item.assigned_to_last_name}}</template>
              <template v-slot:cell(type)="data">
                <p
                  class="link-text"
                  @click="OpenDetailPage('/view-complaint-detail/'+data.item.id)"
                >{{data.item.type}}</p>
              </template>
            </b-table>
            <template v-slot:footer>
              <b-row>
                <b-col cols="2">
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </b-col>
                <b-col cols="6">
                  <p class="text-center">
                    Displaying Results From
                    <b>{{fromRows}}</b> to
                    <b>{{toRows}}</b>
                  </p>
                </b-col>
                <b-col cols="4">
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    aria-controls="my-table"
                  ></b-pagination>
                </b-col>
              </b-row>
            </template>
          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { HTTP } from "../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
export default {
  name: "ComplaintsDashboard",
  data () {
    return {
      itemsBreadcrumb: [
        {
          text: "Dashboard",
          href: "dashboard",
        },
        {
          text: "Complaints",
          href: "#",
          active: true,
        },
      ],
      selected: null,
      totalRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      toRows: 0,
      fromRows: 0,

      staticFields: [
        {
          key: "created_at",
          label: "Age",
          sortable: true,
          width: "8%",
        },
        // { key: "title", label: "Title", sortable: true },

        {
          key: "type",
          label: "Type",
          sortable: true,
          width: "25%",
        },
        {
          key: "comment",
          label: "Complaint",
          sortable: true,
          width: "46%",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          width: "8%",
        },
        {
          key: "owner",
          label: "Owner",
          sortable: false,
          width: "12%",
        },
      ],
      isLoading: false,
    };
  },
  computed: {
    rows () {
      return this.totalRows;
    },
  },
  methods: {
    OpenDetailPage ( url ) {
      this.$router.push( url );
    },
    createdAtDate ( value ) {
      moment.locale( "en" );
      return moment( value ).format( "DD/MM/YYYY" );
    },
    reloadTable () {
      this.$root.$emit( "bv::refresh::table", "users-data-table" );
    },
    async getComplaintsTableData () {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + ( this.sortDesc == true ? "desc" : "asc" ),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      let response = await HTTP(
        "post",
        "api/v1/complaints/get/table/data",
        formData,
        {
          Authorization: token,
        }
      );

      try {
        this.isLoading = false;
        this.fromRows = response.data.from;
        this.toRows = response.data.to;
        this.totalRows = response.data.total;
        return response.data.data;
      } catch ( err ) {
        this.isLoading = false;

        return [err];
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";

.link-text {
  color: rgb(0 123 255);
  text-decoration: none;
  background-color: rgb(0 0 0 / 0%);
  cursor: pointer;
}
.link-text:hover {
  color: rgb(0 86 179);
  text-decoration: underline;
}
.card-body {
  padding: 0px;
}

.fixed-bottom {
  right: auto !important;
  left: auto !important;
}
</style>
